module.exports = __webpack_public_path__ + "img/Stemness-BRCA_10X_IDC.d1e606f8.png";